import React from 'react'
import Typography from '../../atoms/Typography'
import { formatFileSize } from '../../../enviroment/lib/formatters/format-file-size'
import { CardHeader } from './CardHeader'

interface PendingFileCardProps {
  file: File
  isUploading?: boolean
}

export const PendingFileCard: React.FC<PendingFileCardProps> = ({ file, isUploading = false }) => (
  <div className="rounded-lg border border-dashed border-gray-600 p-4">
    <CardHeader name={file.name} />
    {isUploading ? (
      <div className="relative h-1.5 overflow-hidden rounded-full bg-gray-700">
        <div className="absolute h-full w-1/3 animate-infinite-progress rounded-full bg-orange-500" />
      </div>
    ) : (
      <Typography variant="xs" className="text-gray-400">
        {formatFileSize(file.size)}
      </Typography>
    )}
  </div>
)
